export default __webpack_public_path__ + "static/media/preparation-card-img.5861a4a8.png";